import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  children: PropTypes.node,
  layout: PropTypes.string
};

const FormWrapper = ({ children, layout }) => {
  return layout === 'page' ? (
    <div className="search-form-wrapper primary-form">{children}</div>
  ) : (
    children
  );
};

FormWrapper.propTypes = propTypes;

export default FormWrapper;
